import { createRoot } from 'react-dom/client'
import { Head } from '@inertiajs/react';
import React, { useEffect, useRef, useState } from 'react'
import CreateReactScript from './Utils/CreateReactScript'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import SelectSearch from './components/SelectSearch';
import SelectCatalogo from './components/SelectCatalogo';
import Card from './components/Card';

import axios from 'axios';

import WebLayout from '@/Layouts/WebLayout';

import './fade.css';
import { set } from 'sode-extend-react/sources/cookies';
import ProductCard from './components/ProductCard';
import ProductcartUx from './components/ProductcartUx'
import ProductCartSkeleton from './components/ProductCartSkeleton'

import { sub } from 'date-fns';


export default function Catalogo({ categorias, selected_category, categoria, url_env, beneficios, tipoFloresList, subcategoria, categoriaSelected, subcategorias, contenidoDeValor }) {


  const [filter, setFilter] = useState({});
  const query = window.location.search;
  const urlParams = new URLSearchParams(query);
  const subCategoryQuery = urlParams.get('subcat'); // Convertir a número

  const primeraCargaItems = useRef(true)

  let filterverMas = urlParams.get('filter');

  const [contador, setContador] = useState(0)


  const paramsfilter = new URLSearchParams(window.location.search);
  const url = window.location.pathname;
  const segmentos = url.split('/');
  const esMasPedidos = segmentos.includes('mas-pedidos');

  const initialFilters = {
    tipoFlor: paramsfilter.get("tipoFlor") ?? null,
    page: Number(paramsfilter.get("page") ?? 1),
    verMasPedidos: esMasPedidos ?? false
  };



  const take = 12

  const buildFilters = () => ({
    ...(selected_category && {
      category_id: [selected_category],
    }),
    ...(subcategoria && {
      subcategoria: [subcategoria],
    }),
    ...(initialFilters.tipoFlor !== null && {
      tipoFlor: [initialFilters.tipoFlor],
    }),
    ...(initialFilters.verMasPedidos !== null && {
      verMasPedidos: [initialFilters.verMasPedidos],
    }),
    ...(initialFilters.page !== null && {
      page: initialFilters.page,
    }),
  });

  useEffect(() => {
    setFilter(buildFilters());
  }, [selected_category, subcategoria, initialFilters.tipoFlor]);

  const [loadedPages, setLoadedPages] = useState({ min: initialFilters.page, max: initialFilters.page });


  let abortController = new AbortController();
  const [items, setItems] = useState([])


  const [totalCount, setTotalCount] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [namebtn, setNamebtn] = useState('Ver más productos')
  const [namebtnPrev, setNamebtnPrevn] = useState('Ver anteriores')
  const [priceOrder, setPriceOrder] = useState('')
  const [loading, setLoading] = useState(true)
  const [isloading, setIsLoading] = useState(false)
  const [isListVisible, setIsListVisible] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [CatSelected, setCatSelected] = useState(categoria ? categoria.name : '');
  const [florSelected, setflorSelected] = useState('');
  const [subcatSelected, setSubcatSelected] = useState('');
  const [iscategoriaVisible, setIsCategoriaVisible] = useState(false);
  const [listsubcat, setListSubcat] = useState(subcategorias)

  const prevOrNext = useRef(false)





  const itemsubcat = listsubcat.find(subcat => subcat.id == subCategoryQuery)


  const [badges, setBadges] = useState({
    categories: selected_category ? [{ id: `${categoria.id}`, name: categoria.name }] : [],
    priceOrder: '',
    tipoFlor: [],
    subcategoria: subCategoryQuery !== null ? [{ id: subCategoryQuery, name: itemsubcat.name }] : []
  });
  const [currentcat, setCurrentCat] = useState(categoria ? categoria : {})
  const subcatcurrent = useRef(categoriaSelected)
  const [ShowtipoFlores, setShowTipoFlores] = useState(false)
  const [showSubCategorias, setShowSubCategorias] = useState(false)


  // const subcategoriaSelectd = useRef(subcategoria)


  const labelRefs = useRef({});

  const labelTipoFlores = useRef({});
  const labelSubcategoria = useRef({});

  const toggleCattVisibilityTipoFlores = () => {
    setShowTipoFlores(!ShowtipoFlores)
  }

  useEffect(() => {
    // Verificamos que fbq exista y que currentcat tenga datos
    if (window.fbq && currentcat?.name) {
      window.fbq('trackCustom', 'ViewCategory', {
        category: currentcat.name // Dinámico según la categoría actual
      });
    }
  }, [currentcat.name]);


  const arrayJoin = (array = [], separator) => {
    const newArray = []
    array.forEach((x, i) => {
      if (i == 0) {
        newArray.push(x)
      } else {
        newArray.push(separator, x)
      }
    })
    return newArray
  }
  const toggleListVisibility = () => {
    setIsListVisible(!isListVisible);
  };
  const toggleListVisibilitysubcat = () => {
    setShowSubCategorias(!showSubCategorias);
  };

  function updateUrlWithInputId(inputId) {
    const newUrl = inputId ? `/catalogo/${inputId}` : '/catalogo';
    window.history.pushState(null, '', newUrl);
  }
  const dropdownRef1 = useRef(null);
  const dropdownRef2 = useRef(null);
  const dropdownRef3 = useRef(null);
  const dropdownSubcategoria = useRef(null);

  const handleClickOutside = (event) => {

    iscategoriaVisible
    ShowtipoFlores
    isListVisible

    if (dropdownRef1.current && !dropdownRef1.current.contains(event.target)) {
      setIsCategoriaVisible(false);
    }
    if (dropdownRef2.current && !dropdownRef2.current.contains(event.target)) {
      setShowTipoFlores(false);
    }
    if (dropdownRef3.current && !dropdownRef3.current.contains(event.target)) {
      setIsListVisible(false);
    }
    if (dropdownSubcategoria.current && !dropdownSubcategoria.current.contains(event.target)) {
      setShowSubCategorias(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);



  const updateURL = (filters) => {
    // 1️⃣ Tomar los params actuales
    const params = new URLSearchParams(window.location.search);

    // 2️⃣ Actualizar según filtros
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== "" && value !== "todos") {
        params.set(key, value); // agrega o reemplaza
      } else {
        params.delete(key); // elimina si no aplica
      }
    });

    // 3️⃣ Construir nueva URL
    const newUrl = `${window.location.pathname}${params.toString() ? `?${params.toString()}` : ""
      }`;

    // 4️⃣ Reemplazar sin recargar
    window.history.replaceState({}, "", newUrl);
  };

  const handleTipoFloresChange = (event) => {
    setShowTipoFlores(!ShowtipoFlores);

    const inputId = event.target.id;
    const spanContent = labelTipoFlores.current[inputId].querySelector('span').textContent;

    setflorSelected(spanContent);

    if (badges.tipoFlor.find(flor => flor.id == inputId)) {
      return
    }
    setBadges((prevData) => {
      return {
        ...prevData,
        tipoFlor: [{ id: inputId, name: spanContent }]
      }
    });

    setFilter((prevFilter) => {
      return {
        ...prevFilter,
        tipoFlor: [inputId],
        page: 1
      };
    })
    let newfilter = { tipoFlor: inputId, page: 1 }
    updateURL(newfilter)

  }
  const handleSubcategoriaChange = (event) => {


    setShowSubCategorias(!showSubCategorias);

    const inputId = event.target.id;
    const spanContent = labelSubcategoria.current[inputId].querySelector('span').textContent;

    setSubcatSelected(spanContent);


    setFilter((prevFilter) => {
      return {
        ...prevFilter,
        subcategoria: [inputId],
        page: 1
      };
    })
  }

  const getSubcategorias = async () => {

    if (!filter?.category_id?.[0]) return;


    const result = await axios.get(`/api/subcategorias/${filter.category_id[0]}`);
    setListSubcat(result.data)


  }

  useEffect(() => {

    getItems(prevOrNext.current)
    getSubcategorias()
  }, [filter])



  const handleOptionChange = (event) => {


    setIsListVisible(!isListVisible);



    let inputId = event.target.id;
    let spanContent = labelRefs.current[inputId].querySelector('span').textContent;

    // Obtener el contenido del span dentro del label

    setSelectedOption(spanContent);
    setPriceOrder((prevFilter) => {
      return event.target.value
    })
    setBadges((prevFilter) => {
      return { ...prevFilter, priceOrder: event.target.value }
    })

  };
  useEffect(() => {
    setCurrentPage(1)
    getItems()
  }, [priceOrder])



  // Función para eliminar el orden de precio
  const clearPriceOrder = () => {

    setSelectedOption('Ordenar por')
    setBadges((prevData) => ({
      ...prevData,
      priceOrder: ''
    }));

    setPriceOrder('');

  };
  const cleartipoflor = () => {
    setflorSelected('Tipo de Flor');
    setBadges((prevData) => ({
      ...prevData,
      tipoFlor: []
    }));

    setFilter((prevFilter) => {
      return {
        ...filter,
        tipoFlor: []
      };
    })
  }



  const getItems = async (isPrev = false) => {

    if (filter.page == undefined) return;

    abortController.abort('some');
    abortController = new AbortController();
    let signal = abortController.signal;

    setLoading(true)
    setIsLoading(true)
    setNamebtn('Cargando ...')
    setNamebtnPrevn('Cargando ...')

    try {

      const filterBody = []
      let sort = [];
      sort.push({
        selector: 'products.order',
        desc: false,
        raw: true
      })


      if (priceOrder) {
        if (sort.length > 0) {
          sort = []
        }
        if (priceOrder === 'price_high') {
          sort.push({
            selector: 'products.preciofiltro',
            desc: true,
            raw: false
          });
        } else if (priceOrder === 'price_low') {
          sort.push({
            selector: 'products.preciofiltro',
            desc: false,
            raw: false
          });
        } else {
          sort.push({
            selector: 'products.created_at',
            desc: true,
            raw: false
          });
        }
      }

      if (filter['verMasPedidos'] && filter['verMasPedidos'][0] !== false) {
        const maspedidos = [];
        filter['verMasPedidos'].forEach((x, i) => {

          if (x === true) {
            maspedidos.push(['products.destacar', '=', true]);
          }
        });

        filterBody.push(maspedidos);
      }
      if (filter['subcategoria'] && filter['subcategoria'].length > 0) {
        const subcatFilter = [];
        filter['subcategoria'].forEach((x, i) => {
          if (i === 0) {
            subcatFilter.push(['subcategory_id', '=', x]);
          } else {
            subcatFilter.push('or', ['subcategory_id', '=', x]);
          }
        });

        filterBody.push(subcatFilter);
      }
      if (filter['tipoFlor'] && filter['tipoFlor'].length > 0) {
        const sizeFilter = [];

        filter['tipoFlor'].forEach((x, i) => {
          if (i === 0) {
            sizeFilter.push(['tipeFlorPivot.type_flor_id', '=', x]);
          } else {
            sizeFilter.push('or', ['tipeFlorPivot.type_flor_id', '=', x]);
          }
        });

        filterBody.push(sizeFilter);
      }


      if (filter['category_id'] && filter['category_id'].length > 0) {
        const categoryFilter = [];

        filter['category_id'].forEach((x, i) => {
          if (i === 0) {
            categoryFilter.push(['products_has_category.category_id', '=', x]);
          } else {
            categoryFilter.push('or', ['products_has_category.category_id', '=', x]);
          }
        });

        filterBody.push(categoryFilter);
      }
      if (filterverMas !== null && filterverMas == 'destacados') {
        filterBody.push(['products.destacar', '=', true])
      }
      if (filterverMas !== null && filterverMas == 'recomendar') {
        filterBody.push(['products.recomendar', '=', true])
      }


      const result = await axios.post('/api/products/paginate', {
        requireTotalCount: true,
        filter: arrayJoin([...filterBody, ['products.visible', '=', true]], 'and'),
        take,
        skip: take * (filter.page - 1),
        sort
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
        signal: signal
      });



      const { data, totalCount: totalRegistros } = result.data


      if (filter.page == 1 && !isPrev) {

        setItems(data ?? [])

      } else {
        if (isPrev) {
          setItems(prevItems => [...data, ...prevItems]);
        } else {
          // Lógica existente para "Ver más"
          if (contenidoDeValor.length > 0 && contador <= contenidoDeValor.length && contador > 0) {
            let indice = Number(contador) - 1;
            setItems(prevItems => [...prevItems, { ismarketing: true, ...contenidoDeValor[indice] }, ...data]);
          } else {
            setItems(prevItems => [...prevItems, ...data]);
          }
        }
      }
      setNamebtn('Ver más productos')
      setNamebtnPrevn('Ver anteriores')
      setTotalCount(totalRegistros ?? 0)
      setIsLoading(false)
      primeraCargaItems.current = false

      let registrosCargados = take * filter.page

      if (registrosCargados >= totalRegistros) {

        setLoading(false)
      }
      trackViewList(data, filter.page)

    } catch (error) {
      console.error(error)
    }

  }

  const handleCategoryClick = (categoria) => {
    // Simular el comportamiento del filtro de categorías

    setCurrentCat(categoria);
    setCatSelected(categoria.name);
    updateUrlWithInputId(categoria.slug ?? null);


    /* setBadges((prevData) => ({
      ...prevData,
      categories: [{ id: `${categoria.id}`, name: categoria.name }]
    })); */
    setLoadedPages(old => ({
      ...old,
      max: 1
    }));

    setPriceOrder('');
    cleartipoflor()

    setFilter((prevFilter) => ({
      // ...prevFilter,
      category_id: [`${categoria.id}`],
      page: 1
    }));

    updateURL({ page: 1 })

  };

  const trackViewList = (nuevosItems, paginaActual) => {
    // 1. Limpiar el objeto ecommerce (Obligatorio en GA4)
    window.dataLayer.push({ ecommerce: null });

    // 2. Disparar el evento con los nuevos items únicamente
    window.dataLayer.push({
      event: 'view_item_list',
      ecommerce: {
        item_list_id: currentcat.id,
        item_list_name: currentcat.name,
        items: nuevosItems.map((prod, index) => ({
          item_id: prod.sku,
          item_name: prod.producto,
          // item_category: currentcat.name,
          // item_list_name: currentcat.name,
          // item_list_id: currentcat.id,
          // El index debe ser global (ej: si es la pág 2, empieza en 11)
          index: (paginaActual * nuevosItems.length) + index + 1 - nuevosItems.length,
          price: Number(prod.descuento) > 0 ? Number(prod.descuento) : Number(prod.precio),
          currency: 'PEN'
        }))
      }
    });
  };

  const sendProfundidadMetaPixel = (categoryName, nextPage) => {
    if (window.fbq) {
      window.fbq('trackCustom', 'ViewCategoryDepth', {
        category: categoryName || 'General',
        page_number: nextPage,
        action: 'load_more',
        timestamp: new Date().toISOString() // Opcional: para auditoría interna
      });
    }
  };

  const handlecurrentpage = () => {

    const nextPage = loadedPages.max + 1;

    sendProfundidadMetaPixel(currentcat?.name, nextPage);

    setLoadedPages(prev => ({ ...prev, max: nextPage }));
    updateURL({ page: nextPage })
    prevOrNext.current = false
    setFilter(old => (

      {
        ...old,
        page: nextPage
      }));

    setContador(contador + 1)
  }

  const handleLoadPrevious = () => {
    if (filter.page > 1) {
      const prevPage = loadedPages.min - 1;
      prevOrNext.current = true
      setLoadedPages(prev => ({ ...prev, min: prevPage }));
      updateURL({ page: prevPage })
      // Suponiendo que usas un estado para los filtros
      setFilter(prev => ({ ...prev, page: prevPage }));
      // Llamas a la función indicando que es previo
      setContador(contador - 1)
    }
  };

  const seoTitle = currentcat.tittle_page ? `${currentcat.tittle_page}` : "Las Doñas";
  const seoDescription = currentcat.meta_description || 'Las Doñas';







  return (
    <>
      <Head>


        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
      </Head>
      <section className='mb-24'>
        <div className='mt-6 px-[2%] lg:px-[3%] '>

          <div className="w-full h-12 text-center justify-center text-[#4B2907] text-[22px] font-extrabold font-plus_jakarta md:hidden block">Categorías</div>
          <div className='hidden md:flex flex-col gap-3'>

            <div className="w-full h-8 justify-center text-black text-base font-light font-PlusJakartaSans_Regular">
              <span className='w-full flex flex-row items-center gap-2'>
                Inicio <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path d="M5.99998 9.50001C5.90067 9.50059 5.80343 9.47158 5.72067 9.41668C5.63791 9.36178 5.57338 9.28348 5.53529 9.19175C5.49721 9.10003 5.4873 8.99905 5.50684 8.90167C5.52637 8.8043 5.57446 8.71495 5.64498 8.64501L8.29498 6.00001L5.64498 3.35501C5.56306 3.25936 5.52026 3.13632 5.52512 3.01049C5.52998 2.88465 5.58215 2.76528 5.6712 2.67623C5.76024 2.58718 5.87961 2.53502 6.00545 2.53016C6.13129 2.5253 6.25433 2.5681 6.34998 2.65001L9.34998 5.65001C9.4431 5.7437 9.49537 5.87042 9.49537 6.00251C9.49537 6.13461 9.4431 6.26133 9.34998 6.35501L6.34998 9.35501C6.25685 9.44739 6.13115 9.49946 5.99998 9.50001Z" fill="black" />
                  <path d="M2.99998 9.5C2.90067 9.50058 2.80343 9.47157 2.72067 9.41667C2.63791 9.36177 2.57338 9.28346 2.53529 9.19174C2.49721 9.10002 2.4873 8.99904 2.50684 8.90166C2.52637 8.80429 2.57446 8.71494 2.64498 8.645L5.29498 6L2.64498 3.355C2.55083 3.26085 2.49793 3.13315 2.49793 3C2.49793 2.86685 2.55083 2.73915 2.64498 2.645C2.73913 2.55085 2.86683 2.49796 2.99998 2.49796C3.13313 2.49796 3.26083 2.55085 3.35498 2.645L6.35498 5.645C6.4481 5.73868 6.50037 5.86541 6.50037 5.9975C6.50037 6.12959 6.4481 6.25632 6.35498 6.35L3.35498 9.35C3.30867 9.39725 3.25345 9.43483 3.19251 9.46058C3.13157 9.48633 3.06613 9.49973 2.99998 9.5Z" fill="black" />
                </svg>
                <span className=" h-8 items-center flex  text-[#292929] text-base font-light font-PlusJakartaSans_Regular gap-2">

                  Más categorías  </span>
                <span className=" items-center w-64 h-8 flex gap-2 text-[#292929] text-base font-medium font-PlusJakartaSans_Regular">

                  {currentcat.name ? (

                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M5.99998 9.50001C5.90067 9.50059 5.80343 9.47158 5.72067 9.41668C5.63791 9.36178 5.57338 9.28348 5.53529 9.19175C5.49721 9.10003 5.4873 8.99905 5.50684 8.90167C5.52637 8.8043 5.57446 8.71495 5.64498 8.64501L8.29498 6.00001L5.64498 3.35501C5.56306 3.25936 5.52026 3.13632 5.52512 3.01049C5.52998 2.88465 5.58215 2.76528 5.6712 2.67623C5.76024 2.58718 5.87961 2.53502 6.00545 2.53016C6.13129 2.5253 6.25433 2.5681 6.34998 2.65001L9.34998 5.65001C9.4431 5.7437 9.49537 5.87042 9.49537 6.00251C9.49537 6.13461 9.4431 6.26133 9.34998 6.35501L6.34998 9.35501C6.25685 9.44739 6.13115 9.49946 5.99998 9.50001Z" fill="black" />
                        <path d="M2.99998 9.5C2.90067 9.50058 2.80343 9.47157 2.72067 9.41667C2.63791 9.36177 2.57338 9.28346 2.53529 9.19174C2.49721 9.10002 2.4873 8.99904 2.50684 8.90166C2.52637 8.80429 2.57446 8.71494 2.64498 8.645L5.29498 6L2.64498 3.355C2.55083 3.26085 2.49793 3.13315 2.49793 3C2.49793 2.86685 2.55083 2.73915 2.64498 2.645C2.73913 2.55085 2.86683 2.49796 2.99998 2.49796C3.13313 2.49796 3.26083 2.55085 3.35498 2.645L6.35498 5.645C6.4481 5.73868 6.50037 5.86541 6.50037 5.9975C6.50037 6.12959 6.4481 6.25632 6.35498 6.35L3.35498 9.35C3.30867 9.39725 3.25345 9.43483 3.19251 9.46058C3.13157 9.48633 3.06613 9.49973 2.99998 9.5Z" fill="black" />
                      </svg>
                      <span>Categoría  {currentcat.name}</span>
                    </>

                  ) : (
                    ''
                  )}
                </span>

              </span>
              { }
              {subcatcurrent.current && <>{`/ ${subcatcurrent.current.name}`}</>}</div>
            {!currentcat.name && (<div className="w-full h-12 mt-3 text-center justify-center text-[#4B2907] text-4xl font-bold  font-PlusJakartaSans_Regular flex">Categorías</div>)}

          </div>
          <div className="inline-flex md:mt-5 justify-start items-center gap-2.5 overflow-hidden p-1">


            <div className="relative md:mt-5 w-full max-w-[1350px] h-20 items-center flex overflow-hidden">
              <Swiper
                className="productos-relacionados w-[calc(100vw-54px)]  md:w-full"
                modules={[Navigation]}
                slidesPerView={2}
                spaceBetween={10}
                loop={true}
                centeredSlides={false}
                initialSlide={0}
                allowTouchMove={true}
                observer={true}
                observeParents={true}
                watchSlidesProgress={true}
                breakpoints={{
                  480: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 15,
                  },
                  1024: {
                    slidesPerView: 4,
                    spaceBetween: 10,
                  },
                  1200: {
                    slidesPerView: 6,
                    spaceBetween: 10,
                  },
                }}
                navigation={{
                  nextEl: ".swiper-button-next",
                  prevEl: ".swiper-button-prev",
                }}
              >
                {categorias.map((item) => (
                  <SwiperSlide key={item.id} className="!w-auto">
                    <div className={`pl-1.5 h-14 w-full md:min-w-[200px] pr-4 py-2.5 rounded-[5px] hover:border-[#73B473] border outline-neutral-200 inline-flex items-center gap-5 cursor-pointer hover:bg-gray-50 transition-colors ${currentcat.name === item.name ? 'bg-[#E3E3E3] border-[#FF8555]' : ''}`}
                      onClick={() => handleCategoryClick(item)}>
                      <img loading="lazy" className="protect-img !w-12 h-12 rounded-[5px] flex-shrink-0" src={`/img-resize/${item.url_image}?w=48&h=48`} alt={item.name} />
                      <div className="text-center justify-center text-zinc-700 text-lg font-normal font-PlusJakartaSans_Regular truncate flex-1">
                        {item.name}
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>


          </div>

          <div>
            {currentcat.name && (<div className="w-full h-12 mt-3 text-center justify-center text-[#4B2907] text-4xl font-bold  font-PlusJakartaSans_Regular flex">{currentcat.name}</div>)}
          </div>

          <div className='flex flex-row flex-wrap gap-2 md:gap-3 mt-6'>
            {/* Primer select - Filtrar por */}
            {listsubcat.length > 0 && <>
              <div className="relative">
                <div className="flex items-center justify-between gap-3 px-4 py-3 rounded-[10px] border border-neutral-200 bg-white md:min-w-64 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={toggleListVisibilitysubcat}>
                  <span className="text-zinc-800 text-base font-medium font-PlusJakartaSans_Regular">
                    {subcatSelected ? subcatSelected : 'Subcategoria'}
                  </span>
                  <svg className={`w-4 h-4 text-black transform transition-transform ${showSubCategorias ? 'rotate-180' : ''}`}
                    fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </div>


                {showSubCategorias && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-neutral-200 rounded-[10px] shadow-lg z-[100] animate-fade-down animate-duration-[200ms] overflow-y-auto max-h-[150px]">
                    {listsubcat.map((item, index) => (
                      <div key={index} className="w-full">
                        <input
                          type="radio"
                          name={`drop-${index}`}
                          id={item.id}
                          className="radio hidden"
                          value={item.name}
                          onChange={handleSubcategoriaChange}
                        />
                        <label
                          ref={(el) => (labelSubcategoria.current[item.id] = el)}
                          htmlFor={item.id}
                          className="block px-4 py-2 text-base md:font-medium text-zinc-800 hover:bg-gray-50 hover:text-zinc-900 cursor-pointer transition-colors"
                        >
                          <span className="name">{item.name}</span>
                        </label>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>}

            <div className="relative">
              <div
                className="flex items-center justify-between gap-3 px-4 py-3 rounded-[10px] border border-neutral-200 bg-white md:min-w-64 cursor-pointer hover:bg-gray-50 transition-colors"
                onClick={toggleCattVisibilityTipoFlores}
              >
                <span className="text-zinc-800 text-base font-medium font-PlusJakartaSans_Regular">
                  {florSelected ? florSelected : 'Tipo de Flor'}
                </span>

                <svg
                  className={`w-4 h-4 text-black transform transition-transform ${ShowtipoFlores ? 'rotate-180' : ''
                    }`}
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>



              {ShowtipoFlores && (
                <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-neutral-200 rounded-[10px] shadow-lg z-[100] animate-fade-down animate-duration-[200ms] overflow-y-auto max-h-[150px]">
                  {tipoFloresList.map((item, index) => (
                    <div key={index} className="w-full">
                      <input
                        type="radio"
                        name="drop-tipo-flor"
                        id={item.id}
                        className="hidden"
                        onChange={handleTipoFloresChange}
                      />
                      <label
                        ref={(el) => (labelTipoFlores.current[item.id] = el)}
                        htmlFor={item.id}
                        className="block px-4 py-2 text-base md:font-medium text-zinc-800 hover:bg-gray-50 hover:text-zinc-900 cursor-pointer transition-colors"
                      >
                        <span className="name">{item.name}</span>

                      </label>
                    </div>
                  ))}
                </div>
              )}
            </div>





            <div className="relative">
              <div className="dropdown w-full" ref={dropdownRef3}>
                {/* Trigger */}
                <div
                  className="flex items-center justify-between gap-3 px-4 py-3 rounded-[10px] border border-neutral-200 bg-white md:min-w-64 cursor-pointer hover:bg-gray-50 transition-colors"
                  onClick={toggleListVisibility}
                >
                  <span className="text-zinc-800 text-base font-medium font-PlusJakartaSans_Regular">
                    {selectedOption ? selectedOption : 'Precio'}
                  </span>

                  <svg
                    className={`w-4 h-4 text-black transform transition-transform ${isListVisible ? 'rotate-180' : ''
                      }`}
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>

                {/* Dropdown */}
                {isListVisible && (
                  <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-neutral-200 rounded-[10px] shadow-lg z-[100] animate-fade-down animate-duration-[200ms] overflow-y-auto max-h-[150px]">

                    <div className="w-full">
                      <input
                        type="radio"
                        name="drop1"
                        id="id11"
                        className="radio hidden"
                        value="price_high"
                        onChange={handleOptionChange}
                      />
                      <label
                        ref={(el) => (labelRefs.current['id11'] = el)}
                        htmlFor="id11"
                        className="block px-4 py-2 text-base md:font-medium text-zinc-800 hover:bg-gray-50 hover:text-zinc-900 cursor-pointer transition-colors"
                      >
                        <span className="name inline-block w-full">
                          Precio más alto
                        </span>
                      </label>
                    </div>

                    <div className="w-full">
                      <input
                        type="radio"
                        name="drop1"
                        id="id12"
                        className="radio hidden"
                        value="price_low"
                        onChange={handleOptionChange}
                      />
                      <label
                        ref={(el) => (labelRefs.current['id12'] = el)}
                        htmlFor="id12"
                        className="block px-4 py-2 text-base md:font-medium text-zinc-800 hover:bg-gray-50 hover:text-zinc-900 cursor-pointer transition-colors"
                      >
                        <span className="name inline-block w-full">
                          Precio más bajo
                        </span>
                      </label>
                    </div>

                  </div>
                )}
              </div>
            </div>

          </div>

          <div className='grid grid-cols-1 md:grid-cols-4 mt-4 md:mt-12 gap-4 lg:gap-10'>

          </div>


          <div className="flex flex-row w-full items-center justify-center mt-12">


            {(filter.page > 1) &&
              (
                <div className="w-60 h-14 p-2.5 bg-[#FF8555]  hover:bg-[#e6734a] transition-colors duration-300  rounded-[10px] inline-flex justify-center items-center gap-2.5">
                  <button type='button'
                    onClick={() => {
                      handleLoadPrevious()
                    }} className="justify-center text-white text-lg font-bold font-PlusJakartaSans_Regular ">
                    {namebtnPrev}
                  </button>
                </div>
              )
            }

          </div>

          <div className='grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4  mt-16 p-2 gap-[10px] md:gap-2'>

            {isloading && filter.page == 1
              ? Array.from({ length: 4 }).map((_, index) => (
                <ProductCartSkeleton key={`skeleton-${index}`} />
              ))
              : items.map((item, index) => (
                <ProductcartUx key={`product-${index}`} item={item} indexcard={index} contador={items.length} />
              ))}

          </div>

          <div className="flex flex-row w-full items-center justify-center mt-12">


            {loading &&
              (
                <div className="w-60 h-14 p-2.5 bg-[#FF8555]  hover:bg-[#e6734a] transition-colors duration-300  rounded-[10px] inline-flex justify-center items-center gap-2.5">
                  <button type='button'
                    onClick={() => {
                      handlecurrentpage()
                    }} className="justify-center text-white text-lg font-bold font-PlusJakartaSans_Regular ">
                    {namebtn}
                  </button>
                </div>
              )
            }

          </div>



          <div className='mt-14 font-b_slick_bold w-full'>
            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 justify-between'>

              {beneficios.map((beneficio, index) => {
                return (
                  <div key={index} className="col-span-1 items-center esteDiv relative">
                    <ul className="">
                      <li className="">
                        <a className="">
                          <div className="flex flex-row md:flex-col justify-start md:justify-center gap-[3rem] md:gap-0 items-center md:text-center p-6 bg-white rounded-2xl shadow-[0px_0px_4px_1px_rgba(0,0,0,0.10)] h-[100px] md:h-[196px]">
                            <div className="mb-4 w-11 md:w-16 md:h-16 md:flex md:items-center md:justify-center">
                              <img loading='lazy' className="protect-img w-full" src={`/img-resize/${beneficio.icono}?w=64&h=64`} alt={beneficio.titulo} />
                            </div>
                            <div>
                              <h3 className="text-xl font-bold font-dm_sans text-[#4B2907] mb-2">{beneficio.titulo}</h3>
                              <p className="text-gray-600 md:text-center font-dm_sans">{beneficio.descripcionshort}</p>
                            </div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                )
              })}

            </div>
          </div>

        </div>

      </section>

    </>

  )
};



Catalogo.layout = page => <WebLayout children={page} />;